import { render, staticRenderFns } from "./SearchNews.vue?vue&type=template&id=1c061330&scoped=true"
import script from "./SearchNews.vue?vue&type=script&lang=js"
export * from "./SearchNews.vue?vue&type=script&lang=js"
import style0 from "./SearchNews.vue?vue&type=style&index=0&id=1c061330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c061330",
  null
  
)

export default component.exports